module.exports = __webpack_public_path__ + "static/img/1_Contact.db573c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qrcodes/1_Contact.png
// module id = Mh7v
// module chunks = 1